import { LabeledOption } from 'src/Types/globalTypes'

/**
 * This function calculates the kwp display value
 */
export const calculateKwp = (moduleCount: number | undefined, modulePeakPower: number | undefined): string => {
  if (!moduleCount || !modulePeakPower) {
    return ''
  }
  const kwp = (moduleCount * modulePeakPower) / 1000
  return kwp.toFixed(2)
}

/**
 * This function takes a <"MODUL", string> key-value-pair and returns it as a select-value-type
 */
export const mapPVModuleToLabeledOption = (option: { MODUL: string }): LabeledOption<string> => {
  return { label: `${option.MODUL}`, value: `${option.MODUL}` }
}
